@if (isVisible()) {
	<eff-button
		variant="filled"
		tone="neutral"
		size="sm"
		class="ds-admin-console-link__button"
		[route]="adminConsoleRoute"
		dsTestId="shell-admin-console-link"
		(click)="trackOpen()"
	>
		<span class="ds-h-text-weight--bold">Admin</span>
	</eff-button>
}
